import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEO from '@/components/feature/SEO';
import TechImagePanel from '@/components/feature/TechImagePanel';
import Hero from './components/Hero';
import UserLayer from './components/UserLayer';
import ScenarioLayer from './components/ScenarioLayer';
import TransactionLayer from './components/TransactionLayer';
import InfraLayer from './components/InfraLayer';
import GovernanceLayer from './components/GovernanceLayer';

export default function JiuchouArchitecture() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <SEO
        title="九畴云铺五层平台架构 | 用户场景交易基础设施治理"
        description="九畴云铺五层平台架构详解，从用户与角色、业务场景、交易与权益、数字基础设施到平台治理，完整呈现县域数字商业基础设施的运行逻辑。"
        keywords="九畴云铺,五层架构,数字基础设施,平台治理,TOMA智能体,数字货架"
        path="/jiuchou/architecture"
        jsonLd={{
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          name: '九畴云铺五层平台架构',
          description: '五层平台架构详解',
        }}
      />
      <main>
        <Hero />
        <UserLayer />
        <ScenarioLayer />
        <TransactionLayer />
        <TechImagePanel
          eyebrow="五层贯通"
          title="自下而上，一套完整的平台治理系统"
          desc="从用户生态到业务场景、交易权益、数字基础设施与平台治理，五层架构层层贯通，体现九畴云铺作为平台的成熟度。"
          chips={['用户与角色', '业务场景', '交易权益', '数字基础设施', '平台治理']}
          stats={[
            { value: '5 层', label: '平台架构' },
            { value: '6 大', label: '业务场景' },
            { value: '8 项', label: '治理能力' },
          ]}
          imageUrl="https://readdy.ai/api/search-image?query=Abstract%20five%20layer%20platform%20architecture%20cutaway%2C%20deep%20dark%20ink%20navy%20background%2C%20translucent%20stacked%20glass%20layers%20with%20glowing%20emerald%20and%20gold%20connection%20beams%20between%20user%20scenario%20transaction%20infrastructure%20and%20governance%2C%20digital%20commerce%20operating%20system%2C%20isometric%20minimal%20geometric%20composition%2C%20cinematic%20lighting%2C%20high%20detail&width=1600&height=900&seq=jiuchou-panel-arch&orientation=landscape"
          imageAlt="九畴云铺 五层平台架构贯通"
        />
        <InfraLayer />
        <GovernanceLayer />
      </main>
      <Footer />
    </div>
  );
}